import React, { useEffect, useState } from "react";
import { EstimateType } from "../utils/EstimateType";
import EstimateTypeSelector from "../../../../components/ui/utils/EstimateTypeSelector";
import OrganizationSelector from "../../../../components/ui/utils/OrganizationSelector";
import { useOrganizationSelect } from "../../../../hooks/useOrganizationSelect";
import { useCarriers } from "../../../../hooks/useCarriers";
import { useTpas } from "../../../../hooks/useTpas";
import { FilterableSelectGeneric } from "../../../components/GenericInputComponents";
import { EstimateMatchCriteria } from "../../../types";

interface MatchCriteriaSelectorProps {
  matchCriteria: EstimateMatchCriteria;
  setMatchCriteria: (matchCriteria: EstimateMatchCriteria) => void;
  includeTestOrgs?: boolean;
}

const MatchCriteriaSelector: React.FC<MatchCriteriaSelectorProps> = ({ matchCriteria, setMatchCriteria, includeTestOrgs }) => {
  const { carriers } = useCarriers();
  const { tpas } = useTpas();
  const { organizations, selectedOrganization, setSelectedOrganization } = useOrganizationSelect({ includeTestOrgs });

  useEffect(() => {
    setSelectedOrganization(
      organizations.find((organization) => organization.organizationId === (matchCriteria.organizationId ?? "default")),
    );
  }, [matchCriteria]);

  return (
    <div className="flex items-end gap-4">
      <div className="min-w-[200px]">
        <OrganizationSelector
          organizations={organizations}
          selectedOrganization={selectedOrganization}
          onSelect={(org) => {
            const organizationId = org?.organizationId === "default" ? undefined : org?.organizationId;
            setMatchCriteria({ ...matchCriteria, organizationId });
          }}
        />
      </div>
      <div className="min-w-[200px]">
        <EstimateTypeSelector
          value={matchCriteria.estimateType}
          onChange={(estimateType) => {
            setMatchCriteria({ ...matchCriteria, estimateType });
          }}
        />
      </div>
      <div className="min-w-[200px]">
        <label className="block text-sm font-medium text-gray-700 mb-2">TPA</label>
        <FilterableSelectGeneric
          options={tpas}
          value={tpas.find((tpa) => tpa.id === matchCriteria.tpaId)}
          onSelect={(tpa) => {
            setMatchCriteria({ ...matchCriteria, tpaId: tpa?.id });
          }}
          getDisplayValue={(tpa) => tpa.name}
          getKey={(tpa) => tpa.id}
          placeholder="Select TPA..."
        />
      </div>
      <div className="min-w-[200px]">
        <label className="block text-sm font-medium text-gray-700 mb-2">Carrier</label>
        <FilterableSelectGeneric
          options={carriers}
          value={carriers.find((carrier) => carrier.id === matchCriteria.carrierId)}
          onSelect={(carrier) => {
            setMatchCriteria({ ...matchCriteria, carrierId: carrier?.id });
          }}
          getDisplayValue={(carrier) => carrier.name}
          getKey={(carrier) => carrier.id}
          placeholder="Select Carrier..."
        />
      </div>
    </div>
  );
};

export default MatchCriteriaSelector;
